import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dk-detail',
  templateUrl: './dk-detail.component.html',
  styleUrls: ['./dk-detail.component.scss']
})
export class DkDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
